<div class="icheck-primary ">
    <label class="radio m-0 mr-2" style="display: inherit;">
      <input class="mr-1" name="{{name}}" id="{{fieldName}}" type="radio" [value]="caption" (change)="onChange($event)">
      <span class="checkmark"></span>
      <span>{{caption}}</span>
    </label>&nbsp;
</div>